import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Typography,
  Grid2,
  IconButton,
  InputAdornment,
  Stack,
  ButtonGroup,
  Menu,
  Button,
  CircularProgress
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import useGetLocations from "../Hooks/useGetLocation";
import useGetPrograms from "../Hooks/useGetPrograms";
import useGetSemester from "../Hooks/useGetSemester";
import { DatePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";
import useGetSubjects from "../Hooks/useGetSubjects";
import DataStudentGrid from "../Components/DataGrid/DataStudentGrid";
import StudentInfoSession from "../Components/Dialogs/StudentInfoSession";
import FileDownloadLoader from "../Components/Loaders/FileDownloadLoader";
import { useGetStudents } from "../Hooks/useGetStudents";
import StudentFilters from "../Components/Filters/StudentFilters";

const options = [
  { label: "All", value: "all" },
  { label: "Group by students", value: "group_students" },
];


const StudentData = () => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state.role);
  const [inputKey, setInputKey] = useState(null);
  const [donwload, setStartDownload] = useState(false);

  const [openStudentInfo, setOpenStudentInfo] = useState(false);
  const [assessmentInfo, setAssessmentInfo] = useState([]);
  const [sessionInfo, setSessionInfo] = useState([]);

  const { locations } = useGetLocations(role);
  const { programs } = useGetPrograms(role);
  const { subjects } = useGetSubjects(role);
  const { students, downloading, searchForStudents, getStudentInfo, pollStudentFileDownload, requestStudentFile} = useGetStudents();
  const { semesters, loading: semester_loading, error: semester_error } = useGetSemester(role);


  const closeStudentInfo = () => {
    setOpenStudentInfo(false);
    setAssessmentInfo([]);
    setSessionInfo([]);
  };

  const viewSessionInfo = async (id) => {
    const studentInfo = await getStudentInfo(id);
    if (studentInfo) {
        setOpenStudentInfo(true);
        setSessionInfo(studentInfo.data); 
        setAssessmentInfo(studentInfo.assessment_data);
    }
  };

  function download(url) {
    const a = document.createElement("a");
    a.href = url;
    a.download = "download.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  
  useEffect(() => {
    if (!inputKey) {
      return;
    }
    const cleanup = pollStudentFileDownload(inputKey, (url) => {
      download(url);
      setInputKey(null);;
    });
    return () => cleanup;
  }, [inputKey, pollStudentFileDownload])

  const requestFile = async (values, index) => {
    const key = await requestStudentFile(values, options[index].value);
    if ( key ) { setInputKey(key) ;} 
  }
  
  return (
    <Box p={2}>
      <Typography variant="h5" mb={2} sx={{ fontWeight: 600, textAlign: { xs: 'left', md: 'left' } }}
      >
        Student Data
      </Typography>
      <StudentFilters 
        onFilterChange={searchForStudents} 
        requestFile={requestFile} 
        subjects={subjects} 
        programs={programs} 
        semester_loading={semester_loading} 
        semesters={semesters} 
        locations={locations} />

      <FileDownloadLoader open={downloading} />
      <DataStudentGrid 
        data={students} 
        viewSessionInfo={viewSessionInfo} />

        
      <StudentInfoSession 
        sessionInfo={sessionInfo} 
        assessmentInfo={assessmentInfo} 
        open={openStudentInfo} 
        close={closeStudentInfo} />
    </Box>
  );
};

export default StudentData;